<script>
import { sharedData } from '../../../static/js/vue_specific/sharedData';
import PrintButton from './PrintButton.vue';
export default {
  props: [
    'saveBookmarkText',
    'saveBookmarkHiddenText',
    'removeBookmarkText',
    'removeBookmarkHiddenText',
    'edit',
    'lang',
  ],
  components: { PrintButton },
  data() {
    return {
      shared: sharedData,
      canEdit: this.edit?.canEdit || false,
      editUrl: this.edit?.editUrl || false,
      editText: this.edit?.text || 'Redigera',
    };
  },
  methods: {
    async addFavorite() {
      var addEvent = new CustomEvent('favorites.add');
      window.dispatchEvent(addEvent);
    },
    async removeFavorite() {
      var delEvent = new CustomEvent('favorites.remove');
      window.dispatchEvent(delEvent);
    },
  },
};
</script>

<template>
  <div class="save-and-listen">
    <div class="save-and-listen-container">
      <nav
        class="save-and-listen-actions"
        aria-label="Page functions"
        id="breadcrumbs">
        <ul class="page-functions-list list-unstyled">
          <li class="page-functions-list-item">
            <button
              v-if="shared.isFavorite"
              id="bookmarkremove"
              ref="removefavoritebtn"
              class="small-font"
              @click="removeFavorite">
              <i class="material-icons blue" aria-hidden="true">favorite</i>
              <span
                >{{ removeBookmarkText }}
                <span class="sr-only">{{
                  removeBookmarkHiddenText
                }}</span></span
              >
            </button>
            <button
              v-else
              id="bookmarksave"
              ref="addfavoritebtn"
              class="small-font"
              @click="addFavorite">
              <i class="material-icons" aria-hidden="true">favorite_border</i>
              <span
                >{{ saveBookmarkText }}
                <span class="sr-only">{{ saveBookmarkHiddenText }}</span></span
              >
            </button>
          </li>
          <li class="page-functions-list-item">
            <PrintButton />
          </li>
          <li
            v-if="canEdit && editUrl"
            id="edit-container"
            class="page-functions-list-item">
            <a :href="editUrl" class="small-font">
              <i class="material-icons" aria-hidden="true">edit</i>
              <span>{{ editText }}</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
